import client1 from "../agroImg/client1.png";
import client2 from "../agroImg/client2.png";
import client3 from "../agroImg/client3.png";
import client4 from "../agroImg/client4.png";
import client5 from "../agroImg/client5.png";
import AboutC from "../agroImg/aboutC1.png";
import AboutC2 from "../agroImg/ff2.png";

export const clients = [client1, client2, client3, client4, client5];

export const clients2 = [AboutC, client2, client3, AboutC2, client4];
